import "./Separator_module.css";
const Separator_module = {
    separator: "separator__e020cad81faab730",
    separatorLine: "separatorLine__e020cad81faab730",
    horizontal: "horizontal__e020cad81faab730",
    margin: "margin__e020cad81faab730",
    contents: "contents__e020cad81faab730",
    vertical: "vertical__e020cad81faab730"
};
export { Separator_module as default };
